export enum FilterCertificateStatus {
  CURRENT = 0,
  EXPIRED = 1,
  REQUIRED = 2,
}

export interface ICertificationProject {
  id: string;
  name: string;
}

export interface ICertificationItem {
  workerCertificateId: string;
  certificateId: string;
  certificationName: string;
  description: string | null;
  expirationDate: string | null;
  projectNames: ICertificationProject[] | null;
  alias: string | null;
  idNumber: string | null;
  completionDate: string;
  createdAt: string;
  lastUpdatedAt: string;
  groupValidationType: number;
}

export interface IMyCertificationsResponse {
  pageNumber: number;
  pageSize: number;
  totalResults: number;
  items: ICertificationItem[];
}

// Required Certifications specific interfaces
export interface IRequiredCertificationItem {
  id: string;
  alias: string | null;
  name: string;
}

export interface IRequiredCertificationGroup {
  id: string;
  name: string;
  validationType: number;
  certifications: IRequiredCertificationItem[];
  exemptedCertifications: any[];
  existingWorkerMandatoryDeadline: string | null;
  isPresetDefault: boolean;
  existingWorkerGracePeriodInDays: number | null;
  newWorkerMandatoryDeadline: string | null;
  newWorkerGracePeriodInDays: number | null;
  createdAt: string;
  lastUpdatedAt: string;
  isCertificationIdRequired: boolean;
  isDescriptionRequired: boolean;
  isExpirationDateRequired: boolean;
  isMediaRequired: boolean;
}

export interface IRequiredCertificationProjectItem {
  projectId: string;
  projectName: string;
  certificationGroups: IRequiredCertificationGroup[];
}

export interface IRequiredCertificationsResponse {
  pageNumber: number;
  pageSize: number;
  totalResults: number;
  items: IRequiredCertificationProjectItem[];
}
